import { render } from "./WebBotTemplateSettingDashboard.vue?vue&type=template&id=e16501fe&scoped=true"
import script from "./WebBotTemplateSettingDashboard.vue?vue&type=script&lang=js"
export * from "./WebBotTemplateSettingDashboard.vue?vue&type=script&lang=js"

import "./WebBotTemplateSettingDashboard.vue?vue&type=style&index=0&id=e16501fe&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16501fe"]])

export default __exports__